
import { defineComponent } from 'vue';

interface IForm {
  dateFrom: string;
  dateTo: string;
  keyword: string;
}

interface IState {
  form: IForm;
}

export default defineComponent({
  emits: ['search'],
  data() {
    return {
      form: {
        dateFrom: '',
        dateTo: '',
        keyword: '',
      },
    } as IState;
  },
  methods: {
    btnSearchClick() {
      this.$emit('search', this.form);
    },
  },
});
